import React from "react";
import summaryStyle from "./summaryStyle";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type ContractDescriptionProps = {
  formData: Record<string, any>;
  title: string;
};

const ContractDescription = ({ formData, title }: ContractDescriptionProps) => {

  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>{title}</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"personalTextMessage"} sx={summaryStyle.scrollToAnchor} />
        Ihre Situation und Fragen
      </Grid>
      <Grid size={12}>
        {formData.personalTextMessage}
      </Grid>
    </>
  );
};

export default ContractDescription;
